import { generateTitle, generateSidebarTitle } from '@/utils/i18n'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${generateTitle(pageTitle)} - ${generateSidebarTitle()}`
  }
  return `${generateSidebarTitle()}`
}
